import React from "react"

export const Facebook = props => (
  <svg width={19} height={19} {...props}>
    <path
      d="M17.951 0H1.048C.47 0 0 .47 0 1.048v16.904C0 18.53.47 19 1.048 19h9.106v-7.347H7.682V8.775h2.472V6.66c0-2.454 1.494-3.79 3.686-3.79h.004a20.38 20.38 0 0 1 2.207.111V5.55h-1.523c-.147 0-.28.008-.4.025-.831.123-1.008.644-1.008 1.366v1.832h2.85l-.371 2.875h-.016v.005h-2.48V19h4.848c.58 0 1.049-.47 1.049-1.048V1.048C19 .47 18.53 0 17.951 0"
      fill="#FFF"
      fillRule="evenodd"
    />
  </svg>
)
